<template>
  <div @click="navigate" class=" flex w-full my-1 right cursor-pointer">
    <div class="chat">
      <div class="flex w-full">
        <div class="mr-4 p-2">
          <div style="height: 40px; width: 40px;" class="self-start rounded">
            <img
              v-if="user.image"
              class="object-cover w-150 h-150 rounded-full"
              :src="user.image"
              alt=""
            />
            <img
              v-else
              class="object-cover w-150 h-150 rounded-full"
              src="https://picsum.photos/id/1011/3648.jpg"
              alt=""
            />
          </div>
        </div>
        <div class="w-full ">
          <div class="text-tenant-color font-semibold text-md mt-4">
            {{ user.first_name }} {{ user.last_name }}
          </div>
        </div>
      </div>
    </div>
    <hr class="" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "chatBubble",
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {},
  mounted() {
    this.messages = this.chat;
  },
  methods: {
    navigate(id) {
      this.$router.push({
        name: "tenant-survey-user",
        params: {
          survey_id: this.$route.params.survey_id,
          learner_id: this.user.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: #000;
  text-decoration: none;
}
.chat {
  width: 100%;
  .message {
    background-color: #ecf0f3;
    border-radius: 5px;
  }

  &:before {
    content: "";
    width: 0px;
    height: 0px;
    display: block;
    border-left: 5px solid transparent;
    border-right: 5px solid #ecf0f3;
    border-top: 5px solid #ecf0f3;
    border-bottom: 5px solid transparent;
    position: absolute;
    top: 0px;
    left: -3px;
  }
}

.right {
  .message {
    background-color: #0087db;
    color: #ffffff;
  }
}
</style>
